import { Directive } from '@angular/core';
import { StatefulComponent } from '../stateful/stateful.component';
import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';

@Directive({
    selector: '[appPasswordValidation]',
    standalone: true
})
export class PasswordValidationComponent extends StatefulComponent {

  constructor() {
    super();
  }

  passwordValidation(formControl: FormControl): ValidationErrors | null {
    const password = formControl.value;
    const upperRegEx = new RegExp('[A-Z]');
    const lowerRegEx = new RegExp('[a-z]');
    const numberRegEx = new RegExp('[0-9]');
    const specialRegEx = new RegExp('[^a-zA-Z\\d\\s]');

    let upperRegExTest = password.match(upperRegEx);
    let lowerRegExTest = password.match(lowerRegEx);
    let numberRegExTest = password.match(numberRegEx);
    let specialRegExTest = password.match(specialRegEx);

    if (upperRegExTest &&
        lowerRegExTest &&
        numberRegExTest &&
        specialRegExTest) {
      return null;
    } else {
      return {
        upperRegEx: upperRegExTest ? 'valid' : 'invalid',
        lowerRegEx: lowerRegExTest ? 'valid' : 'invalid',
        numberRegExTest: numberRegExTest ? 'valid' : 'invalid',
        specialRegExTest: specialRegExTest ? 'valid' : 'invalid'
      };
    }
  }


}
